import fuzzy from 'fuzzy';
const MAX_RESULTS = 10;
const buildSearchable = (item) => {
    return [item.title, item.description ?? '', ...(item.keywords ?? [])]
        .map((part) => part?.trim().toLowerCase())
        .filter((part) => Boolean(part))
        .join(' ');
};
const buildCandidates = (items) => items.map((item) => ({
    item,
    searchable: buildSearchable(item),
}));
const fuzzyOptions = {
    extract: (candidate) => candidate.searchable,
};
export const filterSlashCommandItems = (items, query) => {
    const normalizedQuery = query.trim().toLowerCase();
    if (!normalizedQuery) {
        return items;
    }
    const candidates = buildCandidates(items);
    const matches = fuzzy.filter(normalizedQuery, candidates, fuzzyOptions);
    const ordered = matches.map((match) => match.original.item);
    if (ordered.length === 0) {
        return [];
    }
    return ordered.slice(0, MAX_RESULTS);
};
